import { CircleX } from "lucide-react"
import { useNavigate } from "react-router-dom"
import {
  clearSelectedBrandID,
  selectSelectedBrandID,
  setSelectedBrandID
} from "../../../redux/slices/conversations"
import { useAppDispatch, useAppSelector, useUserRoles } from "../../hooks"
import If from "../if"
import Options from "./options"

const ConversationsBrandSelector = () => {
  const dispatch = useAppDispatch()

  const navigate = useNavigate()

  const { isSuperAdmin } = useUserRoles()

  const selectedBrandID = useAppSelector(selectSelectedBrandID)

  // If the the user is not superAdmin, return null
  if (!isSuperAdmin) return null

  const handleBrandChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value
    dispatch(setSelectedBrandID(value ? parseInt(value) : undefined))
    resetConversationRoute()
  }

  const handleClearBrand = () => {
    dispatch(clearSelectedBrandID())
    resetConversationRoute()
  }

  // change the route to just conversations using react route
  const resetConversationRoute = () => {
    // change the route to conversations
    navigate("/conversations")
  }

  return (
    <div className="mt-3 flex flex-col relative min-w-72">
      <select
        className="px-4 py-2 form-select border-neutral-200 text-neutral-900 input-base text-sm"
        value={selectedBrandID?.toString() || ""}
        onChange={handleBrandChange}
      >
        <Options />
      </select>
      <If
        condition={!!selectedBrandID}
        then={
          <button
            tabIndex={0}
            type="button"
            className="btn btn-outline-primary absolute right-3 top-3 bg-white"
            onClick={handleClearBrand}
          >
            <CircleX size={16} />
            <span className="sr-only">Clear Brand</span>
          </button>
        }
      />
    </div>
  )
}

export default ConversationsBrandSelector
